/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Thumbnail_Projects_SectionInputs */

const en_explorer_thumbnail_projects_section = /** @type {(inputs: Explorer_Thumbnail_Projects_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projects`)
};

const fr_explorer_thumbnail_projects_section = /** @type {(inputs: Explorer_Thumbnail_Projects_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projets`)
};

const de_explorer_thumbnail_projects_section = /** @type {(inputs: Explorer_Thumbnail_Projects_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekte`)
};

const it_explorer_thumbnail_projects_section = /** @type {(inputs: Explorer_Thumbnail_Projects_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progetti`)
};

const ru_explorer_thumbnail_projects_section = /** @type {(inputs: Explorer_Thumbnail_Projects_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проекты`)
};

const es_explorer_thumbnail_projects_section = /** @type {(inputs: Explorer_Thumbnail_Projects_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proyectos`)
};

const zh_cn2_explorer_thumbnail_projects_section = /** @type {(inputs: Explorer_Thumbnail_Projects_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目`)
};

const ja_explorer_thumbnail_projects_section = /** @type {(inputs: Explorer_Thumbnail_Projects_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクト`)
};

const hi_explorer_thumbnail_projects_section = /** @type {(inputs: Explorer_Thumbnail_Projects_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परियोजनाओं`)
};

const pt_pt2_explorer_thumbnail_projects_section = /** @type {(inputs: Explorer_Thumbnail_Projects_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projetos`)
};

/**
* | output |
* | --- |
* | "Projects" |
*
* @param {Explorer_Thumbnail_Projects_SectionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_thumbnail_projects_section = /** @type {((inputs?: Explorer_Thumbnail_Projects_SectionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Thumbnail_Projects_SectionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_thumbnail_projects_section(inputs)
	if (locale === "de") return de_explorer_thumbnail_projects_section(inputs)
	if (locale === "it") return it_explorer_thumbnail_projects_section(inputs)
	if (locale === "ru") return ru_explorer_thumbnail_projects_section(inputs)
	if (locale === "es") return es_explorer_thumbnail_projects_section(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_thumbnail_projects_section(inputs)
	if (locale === "ja") return ja_explorer_thumbnail_projects_section(inputs)
	if (locale === "hi") return hi_explorer_thumbnail_projects_section(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_thumbnail_projects_section(inputs)
	return en_explorer_thumbnail_projects_section(inputs)
});